export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.domain = {domainName: '', netbiosName: ''};
        this.computerLoginHelpImage = require('./computer-login-help.png');
    }

    save() {
        this.isSaving = true;
        this.DirectoriesResource
            .createDomain(this.companyId, this.directory.id, this.domain)
            .then(() => {
                if (this.domains.length || this.directory.agentConnected === 'ACTIVE') {
                    return this.$state.go('^', {}, {reload: '^'});
                } else {
                    return this.$state.go('company.directory-integration.manage.connection');
                }
            })
            .then(() => this.Alert('success', 'company.directory-integration.manage.domains.add-domain.added'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/add-domain/add-domain.controller.js